import { render, staticRenderFns } from "./section_6.vue?vue&type=template&id=04c05f21&scoped=true&"
import script from "./section_6.vue?vue&type=script&lang=js&"
export * from "./section_6.vue?vue&type=script&lang=js&"
import style0 from "./section_6.vue?vue&type=style&index=0&id=04c05f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c05f21",
  null
  
)

component.options.__file = "section_6.vue"
export default component.exports